import EnglishSentences from "../assets/Vocab/EnglishSentences.json";
import ChineseSentences from "../assets/Vocab/ChineseSentences.json";
import MoominQuotes from "../assets/Vocab/MoominQuotes.json";

const ENGLISH_SENTENCES = EnglishSentences;
const CHINESE_SENTENCES = ChineseSentences;
const MOOMIN_QUOTES = MoominQuotes;

export { ENGLISH_SENTENCES, CHINESE_SENTENCES, MOOMIN_QUOTES };
